<template>
  <div class="buy-button container">
    <a v-if="customerInfoURL" class="kefu" :href="customerInfoURL">
      <img src="../assets/images/goods/kefu.png" class="icon" />
      <p class="text">客服</p>
    </a>
    <van-button
      v-if="show"
      round
      type="primary"
      :class="isVipButton && 'vip-button'"
      @click="clickButton"
      :disabled="isDisable"
    >
      {{ buttonText }}
    </van-button>
  </div>
</template>

<script>
import { isWXBrowser } from '@/utils/browser'

export default {
  name: 'FooterButtonBuy',
  props: ['buttonText', 'isDisable', 'customerInfoURL', 'isVipButton'],
  data() {
    return {
      show: true,
    }
  },
  methods: {
    clickButton() {
      this.$emit('clickButton')
    },
  },
  mounted() {
    console.log('gggggg')
  },
}
</script>

<style lang="scss" scoped>
.buy-button {
  z-index: 100;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1.65rem;
  padding-top: 0.24rem;
  padding-bottom: 0.24rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-top: 0.01rem solid #eee;
  background-color: #fff;
  @include maxWidth();

  .kefu {
    .icon {
      width: 0.53rem;
      margin-left: 0.05rem;
    }

    width: 1.7rem;
    height: 1rem;
  }
}

.vip-button {
  background: linear-gradient(to right, #fee9bb, #f0cc8c);
  border: none;
  color: #6e3600;
  font-weight: bold;
}
</style>
